import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ServiceProductService } from '../service-product.service';
import { ServiceProduct } from '../service-product'

@Component({
    selector: 'app-service-product',
    templateUrl: './service-product.component.html',
    styleUrls: ['./service-product.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ServiceProductComponent implements OnInit {
  //locations: any;
  listingStatus: any;
  locations: any;
  codes: any;
  categories: any;
  

  constructor(
    private primengConfig: PrimeNGConfig,
    private serviceProductService: ServiceProductService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
	private constantService: ConstantService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.formTitle = data.title,
      this.serviceProduct = data.serviceProduct,
     this.locations = constantService.locations;
     this.listingStatus = serviceProductService.listingStatus,
     this.categories = serviceProductService.categories,
     this.codes = serviceProductService.codes
  }

  @Input() serviceProduct: ServiceProduct;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  serviceProductId: number;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  // statuses: any;
  // locations: any;
  // codes: any;
  //listingStatuses: any;
  // categories: any;


  validationMessages = {
    'serviceProductId': [],
    'locationId': [],
    'title': [],
    'description': [],
    'svcCode': [],
    'listingStatus': [],
    'svcCategory': [],
    'itemPurchPrice': [],
    'itemResalePrice': [],
    'svcPurchPrice': [],
    'svcResalePrice': [],
    'defaultSvcMins': [],
    'defaultSvcRate': [],
    'opsNotes': [],
    'publicNotes': [],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole serviceProduct object
    if (this.serviceProduct) {
      this.serviceProductId = this.serviceProduct.serviceProductId;
      this.fixDates();
      this.form1.patchValue(this.serviceProduct);
    }
  }

  onFormDelete() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + this.serviceProductId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete()
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.serviceProductService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.serviceProduct = res.data.serviceProduct;
            this.doAdd.emit(this.serviceProduct);
          },
          (err: any) => {
            console.log('serviceProduct-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('serviceProduct: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.serviceProductService.update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.serviceProduct = res.data.serviceProduct;
            this.doUpdate.emit(this.serviceProduct);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.serviceProductService.delete(this.serviceProduct.serviceProductId)
        .subscribe(
          (res: any) => {
            console.log('serviceProduct-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doDelete.emit(this.serviceProduct);
          },
          (err: any) => {
            console.log('serviceProduct-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      serviceProductId: [this.serviceProductId],
      locationId: [],
      title: [],
      description: [],
      svcCode: [],
      listingStatus: [],
      svcCategory: [],
      itemPurchPrice: [],
      itemResalePrice: [],
      svcPurchPrice: [],
      svcResalePrice: [],
      defaultSvcMins: [],
      defaultSvcRate: [],
      opsNotes: [],
      publicNotes: []

    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.serviceProduct.serviceProductDate = moment(this.serviceProduct.serviceProductDate).toDate();
  }
}
